"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _css = require("@emotion/css");
var _noop = _interopRequireDefault(require("lodash/noop"));
var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _calendar = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/calendar"));
var _alertErrorSmall = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/alert-error-small"));
var _datePicker = _interopRequireDefault(require("@amzn/meridian-tokens/component/date-picker"));
var _input = _interopRequireDefault(require("@amzn/meridian-tokens/component/input"));
var _input2 = _interopRequireDefault(require("../input"));
var _mask = _interopRequireDefault(require("../input/mask"));
var _tooltip = _interopRequireDefault(require("../tooltip"));
var _theme = require("../theme");
var _focus = _interopRequireDefault(require("../_focus"));
var _inputClearButton = _interopRequireDefault(require("../_input-clear-button"));
var _context = _interopRequireDefault(require("../_input-box/context"));
var _inputMonospacePlaceholder = _interopRequireDefault(require("../_input-monospace-placeholder"));
var _token = require("./../_utils/token");
var _dateString = require("./../_utils/date-string");
var _dateLocales = _interopRequireWildcard(require("./../_utils/date-locales"));
var _styles = require("../_input-box/styles");
var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var STANDARD_ICON_SIZE = 24;
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var focus = _ref.focus,
    empty = _ref.empty;
  return (0, _css.css)({
    letterSpacing: focus || !empty ? t("inputValueLetterSpacing") : undefined,
    // HACK: We only accept dates in English numerals for now - since we don't yet
    // support other locale numerals, eg: ١،٢،٣،٤،٥،٦،٨،٩،٠ 一，二，三，四，五, etc.
    // Dates entered in English numerals are read and typed LTR.
    // NOTE: The direction is only forced on focus so that the placeholder
    // will remain in the direction inherited from the parent.
    direction: focus && "ltr"
  });
}, ["focus", "empty"]);

/* eslint-disable react/prop-types */
/**
 * Renders an error icon in the suffix with a tooltip describing the error.
 */
var InvalidInputMessage = function InvalidInputMessage(props) {
  var children = props.children;
  var t = (0, _theme.useTheme)(_input["default"], "input");
  return /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
    title: children,
    open: true,
    position: "top"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "aria-live": "polite",
    className: (0, _styles.iconStyles)(t, {
      tokens: _objectSpread(_objectSpread({}, _alertErrorSmall["default"]), {}, {
        iconAlertErrorSmallHeight: STANDARD_ICON_SIZE,
        iconAlertErrorSmallWidth: STANDARD_ICON_SIZE
      }),
      position: "suffix"
    }),
    "aria-label": children
  }));
};

/**
 * A form control for selecting dates via a numeric input field. This input is
 * unique from other input components in that it tracks the user's partial input
 * via internal state and only triggers onChange once the user has entered a
 * complete, valid date. If the user moves focus away from the input before
 * entering a complete, valid date then the input is cleared automatically.
 */
var DateInputFieldClass = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(DateInputFieldClass, _React$Component);
  var _super = _createSuper(DateInputFieldClass);
  function DateInputFieldClass() {
    var _this;
    (0, _classCallCheck2["default"])(this, DateInputFieldClass);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "localRef", /*#__PURE__*/_react["default"].createRef());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "lastErrorCode", /*#__PURE__*/_react["default"].createRef(""));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setSelectionRangeTimeout", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "assignRefs", function (inputNode) {
      var forwardedRef = _this.props.forwardedRef;
      _this.localRef.current = inputNode;
      if (forwardedRef) {
        // Assign the ref with a function (Class components) or assigning .current
        // (modern functional components using the `useRef` hook)
        if (typeof forwardedRef === "function") {
          forwardedRef(inputNode);
        } else {
          forwardedRef.current = inputNode;
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getDisplayFormat", function () {
      return (0, _dateLocales.getDateLocale)(_this.props.locale).format;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getDisplayValue", function (value) {
      var date = (0, _dateString.parseDateString)(value);
      return date ? (0, _format["default"])(date, _this.getDisplayFormat()) : "";
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getValue", function (displayValue) {
      var date = (0, _dateString.parseDateString)(displayValue, _this.getDisplayFormat());
      return date ? (0, _dateString.toDateString)(date) : "";
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      displayValue: _this.getDisplayValue(_this.props.value),
      focus: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getMask", function () {
      return new _mask["default"](_this.getDisplayFormat().replace(/[MDY]/gi, "#"));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isEmpty", function () {
      return !/[0-9]/.test(_this.state.displayValue);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onFocus", function (event) {
      _this.setState({
        focus: true
      });
      _this.props.onFocus(event);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBlur", function (event) {
      var _this$props = _this.props,
        value = _this$props.value,
        onBlur = _this$props.onBlur;
      _this.setState({
        displayValue: _this.getDisplayValue(value),
        focus: false
      });
      onBlur(event);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onClear", function () {
      var _this$props2 = _this.props,
        onChange = _this$props2.onChange,
        onClear = _this$props2.onClear;
      // Tell owner date was cleared, clear display, and call onClear prop
      onChange("");
      onClear();
      _this.setState({
        displayValue: ""
      });
      // Move focus back to input so user can begin typing new date
      if (_this.localRef.current) {
        _this.localRef.current.focus({
          preventScroll: true
        });
        // HACK: Move cursor to beginning.
        // This _should_ be doable in React input mask but, sadly, is not working 😢 https://github.com/sanniassin/react-input-mask/tree/2.0.4#beforemaskedvaluechange--function
        // This waits a beat for input mask to add its value before moving the cursor.
        _this.setSelectionRangeTimeout = setTimeout(function () {
          return _this.localRef.current.setSelectionRange(0, 0);
        }, 10);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (displayValue) {
      var _this$props3 = _this.props,
        onChange = _this$props3.onChange,
        disabledDates = _this$props3.disabledDates,
        value = _this$props3.value;
      var date = _this.getValue(displayValue);
      _this.setState({
        displayValue: displayValue
      });
      // If a valid date was entered then notify the owner
      if (date && !disabledDates(date)) {
        onChange(date);
      } else if (value) {
        // Otherwise tell the owner that the date was cleared (but don't clear the
        // display value so the user can keep editing towards a valid date)
        onChange(undefined);
      }
    });
    return _this;
  }
  (0, _createClass2["default"])(DateInputFieldClass, [{
    key: "getErrorCode",
    value: function getErrorCode(_ref2) {
      var mask = _ref2.mask;
      // Only validate if the input is in focus
      if (!this.state.focus) return "";
      var full = !this.isEmpty() && !new RegExp(mask.placeholderChar).test(this.state.displayValue);
      var value = this.getValue(this.state.displayValue);
      return full && !value ? "INVALID_DATE" : full && this.props.disabledDates(value) ? "DISABLED_DATE" : "";
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props4 = this.props,
        locale = _this$props4.locale,
        value = _this$props4.value;

      // If a new value was passed in via props then reset the display value
      // *unless* it's a situation where the user is editing the input and the
      // value was cleared out because the user's partial input resulted in an
      // invalid date
      if (value !== prevProps.value && !(this.state.focus && !value)) {
        this.setState({
          displayValue: this.getDisplayValue(value)
        });
      }

      // If a new locale was passed in via props then reset the input's display
      // value
      if (locale !== prevProps.locale) {
        this.setState({
          displayValue: this.getDisplayValue(value)
        });
      }

      // Call `onInvalidDate` if it exists and the error code, indeed, changed.
      if (this.props.onInvalidDate) {
        var errorCode = this.getErrorCode({
          mask: this.getMask()
        });
        // HACK: Because refs are initialized with `null` - fallback to an empty string
        if ((this.lastErrorCode.current || "") !== errorCode) {
          this.props.onInvalidDate(errorCode, this.getValue(this.state.displayValue));
          this.lastErrorCode.current = errorCode;
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.setSelectionRangeTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var props = this.props;
      var state = this.state;
      var focus = props.focus !== undefined ? props.focus : state.focus;
      var empty = this.isEmpty();
      var mask = this.getMask();
      var displayFormat = this.getDisplayFormat().toLocaleUpperCase();
      var errorCode = this.getErrorCode({
        mask: mask
      });
      var showClearButton = props.clearButton && !empty;
      var dateInputFieldId = props.id || (0, _uniqueId["default"])("dateinputfield-");
      var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _datePicker["default"],
        map: (0, _token.getTokenHelper)("datePicker")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement(_focus["default"], {
          onFocus: _this2.onFocus,
          onBlur: _this2.onBlur,
          multipleTargets: true
        }, function (_ref3) {
          var focusProps = _ref3.focusProps;
          return /*#__PURE__*/_react["default"].createElement(_context["default"].Consumer, {
            value: focusProps
          }, function (existingValues) {
            return /*#__PURE__*/_react["default"].createElement(_context["default"].Provider, {
              value: _objectSpread(_objectSpread({}, focusProps), existingValues)
            }, /*#__PURE__*/_react["default"].createElement(_input2["default"], (0, _extends2["default"])({
              ref: _this2.assignRefs,
              className: styles(t, {
                focus: focus,
                empty: empty
              }),
              type: "text"
              // We can set mobile keyboards to numeric here because we
              // take care of date separators ("/", "-", ".", etc)
              ,
              inputMode: "numeric",
              value: state.displayValue,
              suffixIconTokens: showClearButton || errorCode || !props.showIcon ? undefined : _calendar["default"],
              mask: mask,
              disabled: props.disabled,
              focus: props.focus,
              "aria-placeholder": props.placeholder,
              placeholder: focus ? undefined : props.placeholder,
              size: props.size,
              label: props.label,
              error: props.error,
              width: props.width,
              suffix: showClearButton ? /*#__PURE__*/_react["default"].createElement(_inputClearButton["default"], {
                onClick: _this2.onClear,
                label: props.clearButtonLabel
                // HACK: Shrink the radius by 1 so the button radius fits inside the input
                // radius
                ,
                borderRadiusRight: (0, _input["default"])(t.tokens).inputBorderRadius - 1,
                width: STANDARD_ICON_SIZE + (0, _input["default"])(t.tokens).inputSpacingInsetHorizontal
              }) : errorCode ? /*#__PURE__*/_react["default"].createElement(InvalidInputMessage, null, _this2.props.invalidInputMessage(errorCode, _this2.getValue(_this2.state.displayValue))) : null,
              onChange: _this2.onChange,
              onKeyDown: props.onKeyDown,
              inaccessibleAutoFocus: props.inaccessibleAutoFocus,
              autoFill: props.autoFill,
              id: dateInputFieldId,
              constraintText: props.constraintText,
              helperText: props.helperText,
              errorMessage: props.errorMessage
            }, passThroughProps), focus || !empty ? /*#__PURE__*/_react["default"].createElement(_inputMonospacePlaceholder["default"], {
              t: t,
              mask: mask,
              disabled: props.disabled,
              value: state.displayValue,
              displayFormat: displayFormat
            }) : undefined));
          });
        });
      });
    }
  }]);
  return DateInputFieldClass;
}(_react["default"].Component);
/* eslint-enable react/prop-types */
// Forward ref to class component. TODO: update class component
// to functional component.
var DateInputField = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(DateInputFieldClass, (0, _extends2["default"])({}, props, {
    forwardedRef: ref
  }));
});
DateInputField.displayName = "DateInputField";
DateInputField.propTypes = {
  /**
   * A function that will be called when the value of the date input is
   * changed by the user. The new date will be passed to the function as a
   * string with the format YYYY-MM-DD.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   */
  onChange: _propTypes["default"].func.isRequired,
  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * If `constraintText`, `helperText`, and/or an `errorMessage` are provided to
   * the DateInputeField these will be used to generate the `aria-describedby` prop.
   * This can be overridden by explicitly setting `aria-describedby` on the DateInputField.
   *
   * If you are looking to set an accessible `aria-placeholder` for the screen reader, please see the `placeholder` prop details.
   *
   */
  "aria-*": _propTypes["default"].string,
  /**
   * Allow the browser to suggest auto-fill values for this input.
   *
   * Note that not all browsers respect this property. Some browsers (e.g.
   * Chrome 78) may choose to *always* allow auto-fill regardless of the value
   * of this property.
   */
  autoFill: _propTypes["default"].bool,
  /**
   * Appends a button to the input that the user can click to clear the input.
   * This will trigger the `onChange` callback with a value of `""`.
   */
  clearButton: _propTypes["default"].bool,
  /**
   * An accessible label for the clear button. This will not be visible in the UI, but
   * will be read by screen readers.
   */
  clearButtonLabel: _propTypes["default"].string,
  /**
   * Add constraint text to provide critical information regarding content.
   */
  constraintText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   */
  "data-*": _propTypes["default"].string,
  /**
   * This disables interaction with the entire date picker. If you want to
   * disable the selection of specific dates then use the `disabledDates` prop.
   */
  disabled: _propTypes["default"].bool,
  /**
   * A function that can be used to disable specific dates. The function will
   * be passed date strings in the format YYYY-MM-DD and is expected to return
   * true for disabled dates and false otherwise.
   */
  disabledDates: _propTypes["default"].func,
  /**
   * Show the component in an error state. Use this to indicate that the value
   * of the component is invalid.
   *
   * Consider pairing this state with an `errorMessage`.
   */
  error: _propTypes["default"].bool,
  /**
   * An explanation for why the error state has occurred.
   * This will show as an xsmall [Alert](https://meridian.a2z.com/components/alert/) below the DateInputField.
   */
  errorMessage: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  /**
   * This can be used to force the visible focus state of the input on or
   * off. This only affects the display of the focus ring and the date format
   * placeholder, it does not change the focus state of the actual DOM element
   * as far as the browser is concerned.
   */
  focus: _propTypes["default"].bool,
  /**
   * Add helper text to provide additional instruction.
   */
  helperText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  /**
   * Sets an `id` attribute on the component.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,
  /**
   * If set to true then the input will grab focus as soon as it's mounted.
   *
   * This uses HTML's native `autofocus` attribute. Use this sparingly as
   * there are [common accessibility pitfalls](https://www.brucelawson.co.uk/2009/the-accessibility-of-html-5-autofocus/)
   * associated with this behavior.
   */
  inaccessibleAutoFocus: _propTypes["default"].bool,
  /**
   * A function that returns a message for invalid or disabled dates.
   * The function must return a localized string. The string will be displayed
   * to the user to help guide them.
   *
   * Two arguments will be passed to the function. The first argument will be an error code - either
   * "INVALID_DATE" if the user's date doesn't exist (e.g. 2018-40-40) or
   * "DISABLED_DATE" if the user's date has been disabled via the
   * `disabledDates` prop. The second argument will be the date entered by the
   * user in the format YYYY-MM-DD. This argument will only be provided for
   * the "DISABLED_DATE" error code (the "INVALID_DATE" code means we couldn't
   * actually construct a date).
   */
  invalidInputMessage: _propTypes["default"].func,
  /**
   * A label for the date input field.
   *
   * This will be contained within the date picker box if size is set to "xlarge".
   */
  label: _propTypes["default"].string,
  /**
   * The locale to use when rendering the input (e.g. input date format,
   * month names, names of days of the week, etc.).
   */
  locale: _propTypes["default"].oneOf(Object.keys(_dateLocales["default"])),
  /**
   * Text that is shown in place of the input's value when the input is empty.
   *
   * This text is not visible when a value is entered in the input, so it should
   * not contain essential information that should be persisted. For that,
   * consider using the `label` prop.
   */
  placeholder: _propTypes["default"].string,
  /**
   * Show a calendar or error icon in the input. If set to `false`, be sure to use
   * `onInvalidDate` to display an error message to user's when they input an invalid
   * or disabled date.
   */
  showIcon: _propTypes["default"].bool,
  /**
   * Sets the size of the component using a preset.
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),
  /**
   * The currently selected date in the format YYYY-MM-DD. Do not pass partial
   * or invalid dates.
   *
   * Update this when `onChange` is called to ensure the component is interactive
   * (see the documentation for the `onChange` prop).
   */
  value: _propTypes["default"].string,
  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,
  /**
   * This is called when the clear button is clicked (be sure to set `clearButton`
   * to `true`). No arguments are passed to this callback.
   */
  onClear: _propTypes["default"].func,
  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func,
  /**
   * A function that will be called when the user types in an invalid or disabled
   * date. Like `invalidInputMessage`, the function will be called with the error
   * code (`"INVALID_DATE"` for invalid dates like 2018-40-40 or `"DISABLED_DATE"`
   * if the user types in a date disabled by the `disabledDates` prop) as an argument.
   *
   * Unlike `invalidInputMessage`, `onInvalidDate` will be called with an empty error
   * code `""` when the input is corrected.
   */
  onInvalidDate: _propTypes["default"].func,
  /**
   * This is called when the component has focus and a keyboard key is
   * pressed down. The [keydown event](https://developer.mozilla.org/en-US/docs/Web/API/Element/keydown_event)
   * is passed as the first argument to the function.
   */
  onKeyDown: _propTypes["default"].func
};
DateInputField.defaultProps = {
  locale: "en-US",
  onClear: _noop["default"],
  onFocus: _noop["default"],
  onBlur: _noop["default"],
  clearButton: false,
  disabledDates: _noop["default"],
  size: "medium",
  invalidInputMessage: function invalidInputMessage(code) {
    return {
      INVALID_DATE: "This value is not a valid date.",
      DISABLED_DATE: "This date is not available."
    }[code];
  },
  error: false,
  autoFill: true,
  showIcon: true
};
var _default = DateInputField;
exports["default"] = _default;